export default "__VITE_ASSET__Bp6m34z7__"